import axios from 'axios';
import { authInterceptor, logout } from './auth-interceptor';

// Routes are namespaced under /agentforge in the Go backend.
// In dev: same-origin via Caddy reverse_proxy /agentforge/* → localhost:8080
// In prod: VITE_AGENTFORGE_URL points to the AgentForge service directly.
const baseURL = `${import.meta.env.VITE_AGENTFORGE_URL}/agentforge/api/v1`;

const agentforgeHttp = axios.create({
  baseURL,
  withCredentials: true,
});

agentforgeHttp.interceptors.response.use((result) => result.data);

authInterceptor(agentforgeHttp, {
  getAccessToken: () => localStorage.getItem('apiv1Auth'),

  shouldLogout: (error) => {
    const { config, response: { data = {} } = {} } = error;
    return (
      config.url !== '/auth' &&
      ['err_user_deleted', 'err_suspended', 'err_token_invalid'].some((err) =>
        data?.errors?.includes?.(err)
      )
    );
  },

  shouldRefresh: (error) => {
    const res = error?.response;
    const status = res?.status;
    const data = res?.data ?? {};
    if (
      status === 401 &&
      (data?.code === 401 || data?.error === 'Unauthorized')
    ) {
      return true;
    }
    if (data?.errors?.includes?.('err_token_expired')) {
      return true;
    }
    return false;
  },

  logout,
});

export default agentforgeHttp;
